module.exports = __webpack_public_path__ + "static/media/Code.329ff6e0.svg";